import { ActionIcon, Menu, Tooltip, Button } from "@mantine/core";
import { MSIcon } from "components";
import { useTrans } from "core";
import apiService from "../../services/ApiService.js";
import React from "react";
import { useNavigate } from "react-router";
import { Api_Notifications } from "../../../../constants/SubApi.js";

const Notifications = () => {
	const { t } = useTrans();
	const [notifications, setNotifications] = React.useState([]);
	const [isLoading, setIsLoading] = React.useState(true);
	const navigate = useNavigate();
	React.useEffect(() => {
		loadInitial();
	}, []);

	async function loadInitial() {
		setIsLoading(true);
		try {
			let res = [];
			if (localStorage.getItem("token")) {
				res = await apiService.get(`/${Api_Notifications}/all`);
			}
			setNotifications(res);
		} catch (e) {
			console.log("Error loading notifications:", e);
		} finally {
			setIsLoading(false);
		}
	}

	async function markAsRead(id) {
		try {
			await apiService.patch(`/${Api_Notifications}`, { id });
			loadInitial();
		} catch (e) {
			console.log(`Error marking notification ${id} as read:`, e);
		}
	}

	const handleLinkClick = (link) => {
		const regex = /^apartmentsapp:\/\/apartment\/(\d+)$/;
		const match = link.match(regex);

		const regexPublsih = /^apartmentsapp:\/\/apartment\/(unpublished|published)\/(\d+)$/;
		const matchPublish = link.match(regexPublsih);

		if (match) {
			const id = match[1];
			markAsRead(id);
			navigate(`/apartments/publish/${id}`);
		} else if (matchPublish) {
			const id = matchPublish[2];

			markAsRead(id);
			navigate(`/apartments/publish/${id}`);
		}
	};

	const locale = (localStorage.getItem("my-apartmentlanguage") || "ar").replace(/"/g, "").trim().toLowerCase();
	const messageKey = locale === "ar" ? "message_ar" : "message_en";
	const hasNotifications = notifications.length > 0;

	return (
		<Menu shadow="md" width={400} withArrow arrowSize={10}>
			<Menu.Target>
				<Tooltip label={t("appBar.notification")}>
					<ActionIcon
						size={36}
						variant={hasNotifications ? "filled" : "subtle"}
						radius="xl"
						color={hasNotifications ? "red" : "gray"}
					>
						<MSIcon name="BellRing" />
					</ActionIcon>
				</Tooltip>
			</Menu.Target>

			<Menu.Dropdown>
				<Menu.Label>{t("appBar.notification")}</Menu.Label>

				{isLoading && <Menu.Item disabled>Loading...</Menu.Item>}
				{!isLoading && !hasNotifications && <Menu.Item disabled>{t("appBar.NoNewNotifications")}</Menu.Item>}
				{!isLoading &&
					notifications?.map((notification) => (
						<Menu.Item
							key={notification.id}
							onClick={() => {
								handleLinkClick(notification.link);
							}}
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								paddingRight: "10px",
							}}
						>
							<div style={{ flexGrow: 1, marginRight: "10px" }}>{notification[messageKey]}</div>

							<ActionIcon
								component="span"
								size="sm"
								variant="subtle"
								color="blue"
								onClick={(e) => {
									e.stopPropagation();
									markAsRead(notification.id);
								}}
								title="Mark as Read"
							>
								<MSIcon name="CheckAll" />
							</ActionIcon>
						</Menu.Item>
					))}

				{hasNotifications && <Menu.Divider />}
			</Menu.Dropdown>
		</Menu>
	);
};

export default Notifications;
